import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../../Structure/components/Head/Head';
import Footer from '../../../Structure/components/Footer/Footer';
import {
    GET_ANIMALS_PROTECTORA,
    getAnimalsByFilter,
    loadInfoProtectoraDetailFromAnimalId,
    modeEmail,
    resetAnimalsProtectora,
    resetInfoProtectoraDetail,
} from '../../../AnimalList/actions/actionsAnimalList';
import {
    loadInfoAnimalDetail,
    resetInfoAnimalDetail,
} from '../../../Animal/actions/actionsAnimal';
import {getAnimalsRecomendation, resetAnimalsRecomendation,} from '../../../Recomendations/actions/actionsRecomendations';

import {resetFilters} from '../../../AnimalList/actions/actionsFilterAnimals';
import Alert from 'react-s-alert';
import AlertsConteiner from '../../../Shared/components/Alerts/AlertsConteiner';
import {init, sendEmail} from "../../../Shared/actions/actionsContactByEmail";
import {changeStepWaitBlock, showWaitBlock} from "../../../Structure/actions/actionsStructure";
import {PATH_ADOPTAR_ID, PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID} from "../../../../App/RouterAdopta";
import AnimalDetailContainer from "./AnimalDetailContainer";
import LoaderWait from "../../../Shared/components/Alerts/LoaderWait";
import {ADS_TYPES, AdsManagerContainer} from "../../../Ads/components/AdsManagerContainer";
import {DESKTOP_MODE, MOBILE_MODE} from "../../../../config/globalFrontEndConfig";

const ANIMALS_CONTROL = "animals"
const ANIMALS_CONTROL_PROTECTORA = "animalsProtectora"
const ANIMALS_CONTROL_DETAIL = "animalDetail"

class AnimalDetailPage extends Component {


    constructor(props) {
        super(props);
        //console.log("AnimalDetailPage::constructor()");
        this.state = {}
        this.state.infoAnimalDetail = {}
        this.state.animalsProtectoraRequested = false
        this.state.animalsRecomendationRequested = false
        this.state.showLoader = false


        var width = window.innerWidth;
        if (width < 992) {
            this.state.elementsPerPage = 4;
            this.state.elementsPerRow = 2;
        } else {
            this.state.elementsPerPage = 3;
            this.state.elementsPerRow = 3;
        }


        this.loadData = this.loadData.bind(this);
        this.loadDataAnimalsRecomendation = this.loadDataAnimalsRecomendation.bind(this);
        this.loadDataAnimalsProtectora = this.loadDataAnimalsProtectora.bind(this);
        this.EventWaitBlock = this.EventWaitBlock.bind(this);
    }


    loadData() {
        const paramAnimalId = this.props.params.id;

        if (paramAnimalId !== undefined) {
            this.props.loadInfoAnimalDetail(paramAnimalId, ANIMALS_CONTROL);
        }

        this.props.loadInfoProtectoraDetailFromAnimalId(paramAnimalId, ANIMALS_CONTROL, "parcial");

    }

    loadDataAnimalsProtectora(protectoraIdParam) {
        //console.log("AnimalDetailPage::loadDataAnimalsProtectora()");

        if (protectoraIdParam !== undefined) {

            const filter = {
                especie: this.props.infoAnimalDetail.especie.toLowerCase(),
                id_protectora: protectoraIdParam,
                ignoreList: [this.props.infoAnimalDetail._id],
                metadata: {
                    num: this.state.elementsPerPage,
                    pag: 0,
                    polulateProtectora: true
                }
            }
            this.props.getAnimalsByFilter(filter, GET_ANIMALS_PROTECTORA);
        }

    }

    loadDataAnimalsRecomendation(ignoreList) {
        //console.log("AnimalDetailPage::loadDataAnimalsRecomendation()");

        const filter = {
            animal_id: this.props.infoAnimalDetail._id,
            ignoreList: ignoreList,
            especie: this.props.infoAnimalDetail.especie.toLowerCase(),
            metadata: {
                num: this.state.elementsPerPage,
                pag: 0,
                polulateProtectora: true
            }
        }

        this.props.getAnimalsRecomendation(filter);
    }


    EventWaitBlock(event) {
    }

    render() {
        //console.log("AnimalDetailPage::render()");
        let activeCards = {
            animal: true,
            imagenyvideo: true,
            protectora: false,
            metricasAnimal: false
        };
        const paramAnimalId = this.props.params.id
        let showAnimalDetail = false;

        if (this.props.route.path.startsWith(PATH_ADOPTAR_ID) && this.props.infoAnimalDetail && this.props.infoAnimalDetail.nombre) {
            showAnimalDetail = true;
        }
        const isAdminAnimals = (this.props.access && this.props.access.id && this.props.access.id === paramAnimalId && this.props.route && this.props.route.path && this.props.route.path.startsWith(PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID))

        activeCards.metricasAnimal = isAdminAnimals;

        return (
            <div key={"page-" + paramAnimalId} className="">
                <Head
                    previousPath={"protectoraDetail"}
                />
                {this.state.showLoader &&
                    <LoaderWait
                        message={"Enviando email..."}
                    />}

                <div id="main-content" style={{display: "flex"}}>
                    {DESKTOP_MODE && <div className="col-lg-1">
                        {/*<AdsManagerContainer type={ADS_TYPES.SPLITSCREEN} onlyDesktop/>*/}
                    </div>}

                    <div id="animals-list" className="col-lg-8 detailPage container pageAnimalDetail">

                        {showAnimalDetail &&
                            <div>
                                <AnimalDetailContainer
                                    key={"page_container-" + paramAnimalId}
                                    idAnimal={this.props.params.id}
                                    infoAnimalDetail={this.props.infoAnimalDetail}
                                    infoProtectoraDetail={this.props.infoProtectoraDetail}
                                    animalsProtectora={this.props.animalsProtectora}
                                    recomendations={this.props.recomendations}
                                    // idProtectora={protectoraId}
                                    animalsControl={ANIMALS_CONTROL}
                                    animalsControlDetail={ANIMALS_CONTROL_DETAIL}
                                    // isAdminAnimals={isAdminAnimals}
                                    access={this.props.access}
                                    waitBlock={this.props.waitBlock}
                                    onSendEmail={this.onSendEmail}
                                    modeEmail={this.modeEmail}

                                />
                            </div>
                        }

                    </div>
                    {DESKTOP_MODE && <div className="">
                        <AdsManagerContainer type={ADS_TYPES.SKYSCRAPER} onlyDesktop sticky/>
                    </div>}
                </div>
                <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>

                <Footer
                    percent={100}
                    configFooter={
                        {"moreInfo": false}
                    }
                />
            </div>
        );
    }

    componentWillMount() {
        //console.log("AnimalDetailPage::componentWillMount()");
        this.props.resetInfoAnimalDetail()
        this.props.resetInfoProtectoraDetail(ANIMALS_CONTROL)
        this.props.resetAnimalsProtectora()
        this.props.resetAnimalsRecomendation()

        //Initial scroll
        let element = $("body");
        if (element.length !== 0) {
            // console.log("AnimalDetailPage::componentWillMount() -> Haciendo scrollTop");
            $('body,html').stop(true, true).animate({scrollTop: 0}, 450);
        }

        //
        this.loadData(0);

    }

    componentDidMount() {
        //console.log("AnimalDetailPage::componentDidMount()");
        // this.showLoader();
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        //console.log("AnimalDetailPage::componentWillUpdate()");

    }

    componentDidUpdate(prevProps, prevState) {
        //console.log("AnimalDetailPage::componentDidUpdate()");

        //console.log("this.state.animalsProtectoraRequested = '" + this.state.animalsProtectoraRequested + "'");
        //console.log("this.state.animalsRecomendationRequested = '" + this.state.animalsRecomendationRequested + "'");

        if (this.props.params.id !== prevProps.params.id) {
            this.props.resetInfoAnimalDetail()
            this.props.resetInfoProtectoraDetail(ANIMALS_CONTROL)
            this.props.resetAnimalsProtectora()
            this.props.resetAnimalsRecomendation()
            this.setState({
                ...this.state,
                animalsProtectoraRequested: false,
                animalsRecomendationRequested: false
            })


            this.loadData(0)
            //console.log("AnimalDetailPage::componentDidUpdate() -> Haciendo scrollTop");
            $('body,html').stop(true, true).animate({scrollTop: 0}, 450);

        }


        if (this.props.infoAnimalDetail && this.props.infoAnimalDetail._id) {

            if (!this.state.animalsProtectoraRequested) {

                if ((this.props.infoProtectoraDetail && this.props.infoProtectoraDetail._id !== undefined && this.props.infoProtectoraDetail._id !== prevProps.infoProtectoraDetail._id)
                    || ((!this.props.animalsProtectora || !this.props.animalsProtectora.animals || this.props.animalsProtectora.animals.length === 0) && (this.props.infoProtectoraDetail && this.props.infoProtectoraDetail._id))
                    || (this.props.infoAnimalDetail.especie !== prevProps.infoAnimalDetail.especie && this.props.infoProtectoraDetail._id)) {

                    //console.log("Hay protectora nueva cargada!");
                    this.loadDataAnimalsProtectora(this.props.infoProtectoraDetail._id)
                    this.setState({
                        ...this.state,
                        animalsProtectoraRequested: true
                    })
                }
            }

            if (!this.state.animalsRecomendationRequested && ((!this.props.recomendations || !this.props.recomendations.animals || this.props.recomendations.animals.length === 0) && (this.props.animalsProtectora && this.props.animalsProtectora.animals))) {
                //console.log("No hay recomendaciones cargadas y si hay animales de protectora");
                const ignoreList = this.props.animalsProtectora.animals.map((a) => a._id)
                this.loadDataAnimalsRecomendation(ignoreList)
                this.setState({
                    ...this.state,
                    animalsRecomendationRequested: true
                })
            }
        }


    }


}

function mapStateToProps(state, ownProps) {
    return {
        infoAnimalDetail: state[ANIMALS_CONTROL_DETAIL].infoAnimalDetail,
        infoProtectoraDetail: state[ANIMALS_CONTROL_DETAIL].infoProtectoraDetail,
        animalsProtectora: {
            animals: state.animalsProtectora.list,
            totalRecord: state.animalsProtectora.totalRecord,
            pag: state.animalsProtectora.pag
        },
        recomendations: {
            animals: state.recomendations.animals,
        },
        // animalsProtectora: state.animalsProtectora.list,
        // totalRecordProtectora: state.animalsProtectora.totalRecordProtectora,
        // pagProtectora: state.animalsProtectora.pagProtectora,
        // elementsPerRow: state.animalsProtectora.elementsPerRow,
        // elementsPerPage: state.animalsProtectora.elementsPerPage,
        // avanzado: state.reducerFiltersControlProtectora.avanzado,
        // showHead: state.structureControl.showHead,
        // showFooter: state.structureControl.showFooter,
        // animalDetailProtectora: state.animalDetailProtectora,
        // isRemoving: state.animalsProtectora.isRemoving,
        waitBlock: state.structureControl,
        access: state.access,
        // filter: state["reducerFiltersControlProtectora"]
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    loadInfoAnimalDetail,
    getAnimalsByFilter,
    resetFilters,
    sendEmail: sendEmail,
    changeWaitBlock: showWaitBlock,
    changeStepWaitBlock,
    init,
    modeEmail,

    resetInfoProtectoraDetail,
    resetAnimalsProtectora,
    resetInfoAnimalDetail,
    loadInfoProtectoraDetailFromAnimalId,
    getAnimalsRecomendation,
    resetAnimalsRecomendation
})(AnimalDetailPage)
